import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Components
import Badge from "components/Badge";
import {WMSContext} from "../../../../../views/wms/context/WMSContext";
import {getWmsItemUgCode} from "utils/getWmsItemUgCode";

WmsItemCodes.propTypes = {
    wmsItem: PropTypes.object.isRequired,
};

function WmsItemCodes({wmsItem}) {
    const {currentOrganization} = useContext(WMSContext)

    if (!wmsItem || !wmsItem.lineItem) {
        return null;
    }

    return (
        <Grid
            item
            container
            direction={'column'}
            flexWrap={'nowrap'}
            gap={'8px'}
            sx={{overflow: 'auto'}}
        >
            {currentOrganization?.wmsDisplayUgCode && (
                <Badge
                    rounded
                    color={"info"}
                    label={getWmsItemUgCode(wmsItem, currentOrganization)}
                    isBold={false}
                    size={"large"}
                />
            )}
            <Badge
                rounded
                color={"info"}
                label={wmsItem.barcode}
                isBold={false}
                size={"large"}
            />
        </Grid>
    );
}

export default WmsItemCodes;
